import { useSelector } from 'react-redux';
import { calculatePrices } from '../utils/price-calculation';

export function useCart() {
    const pkg = useSelector(
        state => state.cart.confirmed_package ||
            state.packages.selected_package,
    );

    const tickets = useSelector(
        state => state.cart.confirmed_tickets ||
            state.tickets.added_tickets,
    );

    const hotel = useSelector(
        state => state.cart.confirmed_hotel ||
            state.hotels.selected_hotel,
    );

    const nights = useSelector(
        state => state.cart.selected_hotel_nights ||
            state.hotels.selected_hotel_nights,
    );

    const range = useSelector(
        state => state.cart.selected_hotel_range ||
            state.hotels.selected_hotel_range,
    );

    const roomType = useSelector(
        state => state.cart.selected_hotel_room_type ||
            state.hotels.selected_hotel_room_type,
    );

    const optionalHotel = useSelector(
        state => state.cart.optional_hotel ||
            state.hotels.optional,
    );

    const withoutHotel = useSelector(
        state => state.cart.without_hotel ||
            state.hotels.without,
    );

    return calculatePrices(
        pkg,
        tickets,
        hotel,
        roomType,
        nights,
        range,
        null,
        null,
        optionalHotel,
        withoutHotel,
    );
}
